<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <div class="margin-informes">
      <h4 class="color-secundary">Informe de actualización de saldos de cartera</h4>
      <div class="col text-center" v-if="loading" style="padding-top: 100px">
        Por favor espere mientras consultamos los datos...
        <img src="@/assets/images/loader.gif" alt />
      </div>
      <div v-if="!loading" class="row justify-content-center">
        <div
          class="col-lg-4 col-md-6 col-sm-12"
          v-for="infoChart in data"
          :key="infoChart.convenio"
        >
          <h4 style="padding-top: 20px">{{infoChart.modelo}} Código {{ infoChart.convenio }}</h4>
          <apexchart
            type="radialBar"
            :options="infoChart.options"
            :series="infoChart.series"
            ></apexchart>
            <b-button
              block
              variant="outline-primary"
              :disabled="loading || infoChart.series[0] == 0"
              @click="exportar(infoChart)"
              >Exportar {{infoChart.modelo}}</b-button>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import VueChart from "vue-apexcharts";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

const filter = require("./../../filters.js");

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: ""
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn")
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla"
    }),
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    dataInformesError() {
      return this.$store.getters["pages/dataInformesError"];
    },
    data() {
      let datos = Array();
      this.$store.getters["pages/dataInformes"].forEach((element) => {
        let series = element.series.split(",")
        datos.push({
          convenio: element.convenio,
          sig_convenio_id: element.sig_convenio_id,
          modelo: element.modelo,
          series: [
            (series[0] / element.total) * 100,
            (series[1] / element.total) * 100
          ],
          options: {
            plotOptions: {
              radialBar: {
                startAngle: 0,
                endAngle: 380,
                dataLabels: {
                  show: true,
                  name: {
                    show: true
                  },
                  value: {
                    formatter: (w, y) => {
                      return filter.default.numeric(
                        series[y.globals.series.indexOf(parseFloat(w))]
                        );
                      }
                    },
                    total: {
                      show: true,
                      label: "Estado de Cartera",
                      formatter: w => {
                        return w.globals.series[0] > 0
                        ? "Pendientes: " +
                        filter.default.numeric(series[0])
                        : "Actualizada";
                      }
                    }
                  }
                }
              },

              colors: ["#F5541C", "#0077B5"],
              chart: {
                width: 700,
                type: "radialBar"
              },
            labels: ["Pendientes", "Actualizados"],
            legend: {
              show: true,
              formatter: (x, y) => {
                return (
                  x +
                  ": " +
                  filter.default.numeric(series[y.seriesIndex])
                  );
                },
                fontSize: "14px",
                position: "top",
                horizontalAlign: "left"
              }
            }
          });
      });

      return datos;
    },
    loading() {
      return this.$store.state.loading;
    },
    routeName() {
      return this.$router.currentRoute.name;
    }
  },
  methods: {
    async exportar(infoChart) {
      this.$toasted.show("Por favor espere mientras exportamos los datos", {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000
      });
      this.$store.commit("SET_LOADING", true);
      try {
        let result = await this.$store.state.api.get("portal/informes/estado_cartera",{
          params:{
            exportar: 1,
            sig_convenio_id: infoChart.sig_convenio_id
          }
          });

        let data = XLSX.utils.json_to_sheet(result.data.datos, {
          header: ["cedula", "pagare", "convenio", "producto", "Actualizar cortes desde","fecha_desembolso","modelo"]
        });

        data["A1"].v = "Cédula";
        data["B1"].v = "Pagaré";
        data["C1"].v = "Código";
        data["D1"].v = "Producto";
        data["E1"].v = "Actualizar cortes desde";
        data["F1"].v = "Fecha desembolso";
        data["G1"].v = "Modelo";

        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, data, "Cartera Desactualizada");
        var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
        var wbout = XLSX.write(workbook, wopts);
        saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "CarteraDesactualizada.xlsx"
        );

        this.$toasted.show("El archivo fue exportado exitosamente", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000
        });
      } catch (err) {
        this.$toasted.show("Ocurrió un error al intentar exportar el archivo", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000
        });
      }
      this.$store.commit("SET_LOADING", false);
    }
  },
  mounted() {
    this.$store.dispatch("pages/fetch", {
      endpoint: "portal/informes/estado_cartera"
    });
  }
};
</script>